import React, { FunctionComponent, useEffect, useState } from 'react';
import ProfileDetail from '../components/user/ProfileDetail';
import './CheckProfile.css'
import Users from '../models/Users';
import { getAllUsers, getUserById } from '../services/usersServices';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { GetRole } from "../models/role";
import {Session} from "../services/auth-service";

const CheckProfile: FunctionComponent = () => {
    const history = useHistory();
    const [users, setUsers] = useState<Users[]>([]);

    if (Session().id === 0) {
        history.push('/login');
    }
    useEffect(() => {
        if (Session().role_id === GetRole.DIRECTOR) {
            getAllUsers().then(user => setUsers(user));
        } else {
            getUserById(Session().id).then(user => setUsers([user]));
        }
    }, []);

    const createUser = () => {
        history.push(`/CreateUser`);
    }
    return (
        <div className="hero-auto">
            <div id="heroProfileEnfant">
                <h3 className="text-center mt-5 p-5 titleStyle text-light">Profils utilisateurs</h3>
                {Session().role_id === GetRole.DIRECTOR ?
                    <div className="d-flex justify-content-center">
                        <Button className="text-lowercase m-1" variant="success" onClick={() => createUser()}>
                            Créer un utilisateur
                        </Button>
                    </div>
                    :
                    <div>
                    </div>
                }
                <div className="col-12 d-flex flex-wrap justify-content-center">
                    {users ?
                        users.map((user) => (
                            <ProfileDetail key={user.id} user={user} />
                        )): <h3>No user</h3>
                    }
                </div>
            </div>
        </div>
    );
}

export default CheckProfile;
